import { ShoppingCartOutlined } from '@ant-design/icons';
import { Badge } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { isEmpty } from 'underscore';
import { StoreContext } from '../../../store/store';
import styles from '../style/ShoppingCart.module.scss';

export default function ShoppingCartButton() {
  const { shoppingItems } = useContext(StoreContext);

  const [shoppingItemsCount, setShoppingItemsCount] = useState(0);

  useEffect(() => {
    let noItems = 0;
    if (!isEmpty(shoppingItems)) {
      Object.keys(shoppingItems).forEach((pointName: string) => {
        noItems += Object.keys(shoppingItems[pointName]).length;
      });
    }
    setShoppingItemsCount(noItems);
  }, [shoppingItems]);

  return (
    <Badge count={shoppingItemsCount} className={styles.cartBadge}>
      <ShoppingCartOutlined className={styles.cartIcon} />
    </Badge>
  );
}
